import { useState, useEffect } from 'react';
import axios from 'axios';
import AppShell from '../components/layout/AppShell';
import AppFooter from '../components/layout/AppFooter';
import TopNav from '../components/layout/TopNav';

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function Interventions({ onLogout, onNavigate }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(`${API}/invoices`, { headers });
        setInvoices(res.data);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    }
    fetchData();
  }, []); // eslint-disable-line

  return (
    <AppShell
      header={<TopNav isLoggedIn={true} onLogout={onLogout} onNavigate={onNavigate} />}
      footer={<AppFooter onNavigate={onNavigate} />}
      onNavigate={onNavigate}
    >
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '28px 20px' }}>
        <h1 className="page-title">Mes factures</h1>

        {loading ? (
          <div className="section-card"><p className="muted">Chargement…</p></div>
        ) : invoices.length === 0 ? (
          <div className="section-card">
            <div className="empty-state">
              <div className="empty-icon">🧾</div>
              <p className="empty-title">Aucune facture</p>
              <p className="empty-sub">Vos récapitulatifs apparaîtront ici après votre première facture.</p>
            </div>
          </div>
        ) : (
          <div className="section-card">
            {invoices.map((inv, i) => (
              <div key={inv.id} style={{
                padding: '16px 0',
                borderBottom: i < invoices.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontSize: 20 }}>🧾</span>
                    <div>
                      <p style={{ fontWeight: 600, margin: '0 0 2px', fontSize: 14 }}>
                        Ticket #{inv.ticket_id} — {inv.ticket_description}
                      </p>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <span className="muted" style={{ fontSize: 12 }}>
                          {new Date(inv.created_at).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </span>
                        <span className="muted" style={{ fontSize: 12 }}>· {inv.duration_minutes} min</span>
                        {inv.ticket_type === 'express' && (
                          <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 999, background: 'rgba(74,222,128,0.12)', border: '1px solid rgba(74,222,128,0.25)', color: '#4ade80' }}>
                            ⚡ EXPRESS
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: '#fff' }}>
                      {parseFloat(inv.amount).toFixed(2)} €
                    </div>
                    <span className="muted" style={{ fontSize: 11 }}>
                      {inv.ticket_type === 'express' ? 'Fix Express' : 'À la demande'}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}